import { useContext } from 'react'
import { components } from 'react-select'

import { MultiSelectContext } from '../multi-select-context'
import s from './select-checkbox-dropdown.module.scss'
import cn from 'classnames'

const SelectCheckboxDropdown = props => {
  const { state } = useContext(MultiSelectContext)
  const { expandedCheckboxParents } = state

  const displayOption = props.data && props.data.parentLabel
    ? expandedCheckboxParents.includes(props.data.parentLabel)
    : true

  if (!displayOption) return null

  return (
    <components.Option {...props} >
      <div className={cn(s['container'], props.data.parentLabel ? s['child-margin'] : '')}>
        <input
          type="checkbox"
          className={s['cursor-pointer']}
          checked={props.isSelected}
          onChange={() => null}
        />
        <label className={s['cursor-pointer']}>
          {props.label}
        </label>
      </div>
    </components.Option>
  )
}

export default SelectCheckboxDropdown
